export const USERS_APPROVED_WITH_COURSE_REQ = "courseApprovedWithUserReq";
export const USERS_APPROVED_WITH_COURSE_SUCCESS =
  "courseApprovedWithUserSuccess";
export const USERS_APPROVED_WITH_COURSE_FAIL = "courseApprovedWithUserFail";
